import React from 'react';
import Styles from "./shipping.module.css";

export function Shipping() {
    

    return (
        <div className={Styles.shipping}>
            <p>
                Scavenge has been designed just around you. That means it is
                simple and secure to buy and sell your favourite things. 
                The integrated payment and shipping services
                allow you to make transactions and manage shipment difficulties
                making it easy to buy and sell. Enjoy the convenience of
                integrated shopping and secure payments When you sell 
                on Scavenge.
            </p>

           <p>
                As a seller you decide the best appropriate shipping suitable for you 
                and the buyer. NIPOST is the recommended shipping option. 
                However, you can decide to explore other shipping options
                that is convenient for you. 
                Take images of your item, include 
                any further information, and add the price.
                Tap "Upload" to make your listing live. 
                The cost of delivery is always covered by buyers. 
                You will receive a shipping label or shipping
                instructions. Then you must attach the shipping label to 
                the parcel and drop it off to the shipping provider. 
                You must ship the item within 5 days of the purchase, 
           </p>
        </div>
    )
}